import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8 col-xxl-8 col-sm-12 p-0" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { class: "col-md-4 col-xxl-4 col-sm-12 p-0" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-black fw-semibold" }, "Détails commandes four.", -1)),
      _createVNode(_component_router_link, {
        to: "/bons-commandefournisseurs/liste-commandefournisseurs",
        class: "btn btn-primary transition border-0 lh-1 fw-medium",
        style: {"position":"absolute","right":"10px","top":"10px"}
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1" }, null, -1),
          _createTextVNode(" Retour ")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Informations commande four.", -1)),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Date Com Four.", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.format_date(_ctx.commandefournisseur?.dateOperation)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "Référence Doc", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.commandefournisseur?.refDoc), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "Type Opération", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.commandefournisseur?.typeOperation), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "Fournisseur", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.getFournisseurName(_ctx.commandefournisseur?.fournisseur)), 1)
              ])
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("div", { class: "col" }, [
              _createElementVNode("h5", { class: "text-black fw-bold mt-4" }, "Les produits du bon de commande")
            ])
          ], -1)),
          _createElementVNode("table", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Produit"),
                _createElementVNode("th", null, "Qté Com."),
                _createElementVNode("th", null, "Reste à livrer")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commandefournisseur?.produitcondibons, (produitcondibon, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(produitcondibon.nomProd.split("|")[1]) + " " + _toDisplayString(produitcondibon.nomProd.split("|")[2]), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.separateur(produitcondibon.qteBon)) + " " + _toDisplayString(produitcondibon.uniteMesure), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.separateur(produitcondibon.resteAliv)) + " " + _toDisplayString(produitcondibon.uniteMesure), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "text-black fw-bold mb-10" }, "Image du Bon", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
          (_ctx.commandefournisseur?.imageBon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.getUrlApiForProductFiles(_ctx.commandefournisseur?.imageBon),
                class: "d-block w-100",
                alt: "Photo"
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}